export const apiKey = process.env.REACT_APP_API_KEY || "dacd0781379279f479f578091eae6a35212e7837f1f9bf61290bfdd3a216cfbb";
export const API = process.env.REACT_APP_API_URL || "https://krish.staging.spriveapps.com/api/v1";
